import moment from "moment";
import { useEffect, useState } from "react";

import { getOrders } from "../../../api/orders/getOrders";
import { OrderPending, OrderResult } from "../../../api/types/order.type";
import { translationsContent } from "../../../localization/translations";
import { useLanguage } from "../../../store/lang.context";
import { translate } from "../../../utils/translate";
import TransparentButton from "../../ui/button/TransparentButton";
import OrderHistoryCard from "../../ui/cards/orderCard/OrderHistoryCard";
import OrderPendingCard from "../../ui/cards/orderCard/OrderPendingCard";
import classes from "./orderHistory.module.scss";

const OrderHistory = () => {
  const [pendingOrders, setPendingOrders] = useState<OrderPending[]>();
  const [historyOrders, setHistoryOrders] = useState<OrderResult[]>();
  const [orderCount, setOrderCount] = useState<number>(0);
  const [offset, setOffset] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { language } = useLanguage();

  const getDifferenceInMinuteForPending = (order: OrderResult) => {
    const currentDate = moment(new Date());
    const pendingDate = moment(order.pickup_time);
    const dur = moment.duration(pendingDate.diff(currentDate)).asMinutes();
    return dur;
  };

  const CheckIfOrderIsPending = (order: OrderResult) => {
    return getDifferenceInMinuteForPending(order) >= 0;
  };

  const CheckIfOrderIsHistory = (order: OrderResult) => {
    return getDifferenceInMinuteForPending(order) < 0;
  };

  const getData = () => {
    setIsLoading(true);
    getOrders(5, offset)
      .then((response) => {
        let history: OrderResult[] = [];
        let pending: OrderPending[] = [];
        if (response.success && response.data) {
          history = response.data.results.filter(CheckIfOrderIsHistory);
          pending = response.data.results
            .filter(CheckIfOrderIsPending)
            .map((order) => {
              return {
                ...order,
                minutesLeft: getDifferenceInMinuteForPending(order),
              };
            });
          setHistoryOrders(history);
          setPendingOrders(pending);
          setOrderCount(response.data.count);
        }
      })
      .catch(() => {})
      .then(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset]);

  return (
    <div className={classes.container}>
      {!!pendingOrders && pendingOrders.length > 0 && (
        <>
          <h2 className={classes.title}>
            {translate(translationsContent, "historyHeader1", language)}
          </h2>
          {pendingOrders.map((order, i) => {
            return <OrderPendingCard key={`pending-order-${i}`} {...order} />;
          })}
        </>
      )}

      {!!historyOrders && historyOrders.length > 0 && (
        <>
          <h2 className={classes.title}>
            {translate(translationsContent, "historyHeader2", language)}
          </h2>
          {historyOrders.map((order, i) => {
            return <OrderHistoryCard key={`history-order-${i}`} {...order} />;
          })}
        </>
      )}
      <div className={classes.pagination}>
        <TransparentButton
          label={`${translate(translationsContent, "historyPrev", language)}`}
          disabled={offset == 0 || isLoading}
          onClick={() => {
            setOffset(offset - 5);
          }}
        />
        <span>|</span>
        <TransparentButton
          label={`${translate(translationsContent, "historyNext", language)}`}
          disabled={orderCount - offset <= 5 || isLoading}
          onClick={() => {
            setOffset(offset + 5);
          }}
        />
      </div>
    </div>
  );
};

export default OrderHistory;
